import Model from '@/models/Model'

export default class APayable extends Model {
    resource() {
        return 'payable'
    }
}
